module.exports = __webpack_public_path__ + "static/img/product_2.0995e08.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/product_2.png
// module id = oW1Y
// module chunks = 15